"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersService = void 0;
class MembersService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1CompaniesMembers({ companyId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/{companyId}/members',
            path: {
                companyId: companyId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    postApiV1CompaniesMembers({ companyId, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/{companyId}/members',
            path: {
                companyId: companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    deleteApiV1CompaniesMembers({ companyId, memberId, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/companies/{companyId}/members/{memberId}',
            path: {
                companyId: companyId,
                memberId: memberId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV2WorkspacesMembers({ workspaceId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/workspaces/{workspaceId}/members',
            path: {
                workspaceId: workspaceId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    postApiV2WorkspacesMembers({ workspaceId, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v2/workspaces/{workspaceId}/members',
            path: {
                workspaceId: workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    deleteApiV2WorkspacesMembers({ workspaceId, memberId, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v2/workspaces/{workspaceId}/members/{memberId}',
            path: {
                workspaceId: workspaceId,
                memberId: memberId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.MembersService = MembersService;
